import apiService from "../../api/api.service";
import { ProductDetailResponse, BottomGroupProductsResponse } from "./productDetail.types";

export const fetchProductDetail = (slug: string, variantId?: number) => {
  const params = variantId ? { product_variant_id: variantId } : {};
  return apiService.get<ProductDetailResponse>(`/products/slug/${slug}`, { params });
};

export const fetchBottomGroupProducts = (productId: number, key: string) => {
  return apiService.post<BottomGroupProductsResponse>(
    `/products/${productId}/bottom-group-products`,
    { key }
  );
};

export const fetchModalContent = (productId: number, type: "combine" | "ai") => {
  return apiService.post<import("./productDetail.types").ModalContentResponse>(
    `/products/${productId}/detail-modal-contents`,
    { type }
  );
};